const BASE_URL = process.env.REACT_APP_BASE_URL;
const PESONALAREA = process.env.REACT_APP_PESONALAREA;

const MONITORING = process.env.REACT_APP_MONITORING;
const AUTH = process.env.REACT_APP_AUTH

const PURCHASE = process.env.REACT_APP_PURCHASE;

export {BASE_URL, PESONALAREA, AUTH, PURCHASE,MONITORING};
